import WithRender from "./SearchBar.html";
import SearchIcon from "../../base/icons/SearchIcon";

export default WithRender({
  components: {
    SearchIcon
  }
});
